import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useRef } from 'react';
import classNames from 'classnames/bind';
import { Button, Text } from '@carnica/ui-kit';
import { IconArrowsRight } from '@carnica/graphics';
import { LegalBadge } from "../../../../../../../../components/LegalBadge";
import { Metric, headerMetric } from "../../../../../../metric";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var IconArrowsRightModified = function IconArrowsRightModified(circleTheme) {
  return function (params) {
    return /*#__PURE__*/React.createElement(IconArrowsRight, _extends({}, params, {
      className: cn('button-arrow', "button-arrow--".concat(circleTheme)),
      color: circleTheme === 'light' ? 'white' : 'black',
      size: 16,
      "data-t-id": "components-MobileBanner"
    }));
  };
};
export var MobileBanner = function MobileBanner(_ref) {
  var banner = _ref.banner,
    category = _ref.category,
    tab = _ref.tab;
  var imageStyles = banner.imageStyles,
    contentStyles = banner.contentStyles,
    linkHref = banner.linkHref,
    _banner$linkTarget = banner.linkTarget,
    linkTarget = _banner$linkTarget === void 0 ? '_self' : _banner$linkTarget,
    bannerText = banner.bannerText,
    buttonText = banner.buttonText,
    logoSrc = banner.logoSrc,
    _banner$circleTheme = banner.circleTheme,
    circleTheme = _banner$circleTheme === void 0 ? 'light' : _banner$circleTheme,
    textColor = banner.textColor,
    imageUrl = banner.imageUrl,
    _banner$type = banner.type,
    type = _banner$type === void 0 ? 'badge' : _banner$type,
    direction = banner.direction,
    backgroundColor = banner.backgroundColor,
    bannerDescription = banner.bannerDescription,
    legalText = banner.legalText,
    textBadge = banner.textBadge,
    theme = banner.theme;
  // для открытия тултипа
  var bannerRef = useRef(null);
  var combinedStyles = _objectSpread(_objectSpread(_objectSpread({}, imageStyles), imageUrl ? {
    backgroundImage: "url(".concat(imageUrl, ")")
  } : {}), {}, {
    backgroundColor: backgroundColor
  });
  return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      bannerTitle: bannerText,
      bannerDescription: bannerDescription,
      bannerUrl: linkHref,
      sectionText: category === null || category === void 0 ? void 0 : category.title,
      tabName: tab === null || tab === void 0 ? void 0 : tab.title
    }),
    events: {
      headerMetric: ['handleNavBannerEvent']
    },
    mode: "viewport",
    once: true
  }, /*#__PURE__*/React.createElement("a", {
    className: cn('banner'),
    href: linkHref,
    onClick: function onClick() {
      return headerMetric.handleNavBannerClick(JSON.stringify({
        bannerTitle: bannerText,
        bannerDescription: bannerDescription,
        bannerUrl: linkHref,
        sectionText: category === null || category === void 0 ? void 0 : category.title,
        tabName: tab === null || tab === void 0 ? void 0 : tab.title
      }));
    },
    ref: bannerRef,
    style: combinedStyles,
    target: linkTarget,
    "data-t-id": "components-MobileBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('banner__wrapper'),
    style: contentStyles
  }, logoSrc && /*#__PURE__*/React.createElement("div", {
    className: cn('banner__logo-wrapper')
  }, /*#__PURE__*/React.createElement("img", {
    alt: "logo",
    className: cn('banner__logo'),
    src: logoSrc
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('banner__info')
  }, bannerText && /*#__PURE__*/React.createElement(Text, {
    className: cn('banner__title'),
    color: textColor || 'primary-invert',
    size: "m"
  }, bannerText), bannerDescription && /*#__PURE__*/React.createElement(Text, {
    className: cn('banner__title'),
    color: textColor || 'primary-invert',
    size: "xs"
  }, bannerDescription)), buttonText && /*#__PURE__*/React.createElement(Button, {
    className: cn('banner-button'),
    iconRight: IconArrowsRightModified(circleTheme),
    iconRightView: "background",
    mode: "inline"
  }, /*#__PURE__*/React.createElement(Text, {
    color: textColor || 'primary-invert',
    size: "xs",
    "data-t-id": "components-MobileBanner"
  }, buttonText))), legalText && type === 'text' && /*#__PURE__*/React.createElement(Text, {
    className: cn('banner__legal'),
    color: textColor,
    variant: "caption-medium"
  }, legalText), legalText && type !== 'text' && /*#__PURE__*/React.createElement(LegalBadge, {
    className: cn('banner__legal'),
    containerRef: bannerRef,
    direction: direction,
    text: legalText,
    textBadge: textBadge,
    theme: theme,
    tooltipClassName: cn('banner__legal-tooltip'),
    type: banner.type
  })));
};